import type { ApiClient } from './client';

/** ANX-067: статус активации tenant'а для онбординг-чеклиста. */
export interface OnboardingChecklist {
  widgetInstalled: boolean;
  /** Домен последней загрузки виджета (для подписи «активен на X»). */
  widgetDomain: string | null;
  teamInvited: boolean;
  officeHoursSet: boolean;
  themeCustomized: boolean;
  firstConversation: boolean;
  complete: boolean;
}

interface ChecklistRaw {
  widget_installed: boolean;
  widget_domain: string | null;
  team_invited: boolean;
  office_hours_set: boolean;
  theme_customized: boolean;
  first_conversation: boolean;
  complete: boolean;
}

export async function getOnboardingChecklist(client: ApiClient): Promise<OnboardingChecklist> {
  const raw = await client.request<ChecklistRaw>('/api/v1/me/onboarding');
  return {
    widgetInstalled: raw.widget_installed,
    widgetDomain: raw.widget_domain,
    teamInvited: raw.team_invited,
    officeHoursSet: raw.office_hours_set,
    themeCustomized: raw.theme_customized,
    firstConversation: raw.first_conversation,
    complete: raw.complete,
  };
}
